import { useTranslation } from 'react-i18next';

export default function Modal({ title, onClose, children }) {
    const { t } = useTranslation();
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <button type="button" className="modal-close" onClick={onClose} aria-label={t('common.close')}>
                        &times;
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}
